export default __webpack_public_path__ + "static/media/datacamp.b3aa8309.png";